import {
  MdLink as LinkIcon,
  MdImage as ImageIcon,
  MdKeyboardVoice as MicIcon,
  MdEdit as EditIcon,
} from 'react-icons/md';
import type { ImportView } from './ImportSheet';

export const TABS: { key: ImportView; icon: React.ElementType; label: string; hint: string }[] = [
  { key: 'url',   icon: LinkIcon,  label: 'URL',     hint: 'Paste a link from any recipe site, Instagram or TikTok'  },
  { key: 'image', icon: ImageIcon, label: 'Photo',   hint: 'Upload a photo of a recipe card, cookbook or screenshot' },
  { key: 'text',  icon: MicIcon,   label: 'Dictate', hint: "Paste or dictate a recipe and we'll extract the details" },
  { key: 'manual' as unknown as ImportView, icon: EditIcon, label: 'Manual', hint: 'Build a recipe from scratch' },
];
